import { gsap } from 'gsap';
import { map, lerp, getMousePos, calcWinsize, getRandomNumber } from './utils';

// Calculate the viewport size
let winsize = calcWinsize();
window.addEventListener('resize', () => winsize = calcWinsize());

// Track the mouse position
let mousepos = {x: winsize.width/2, y: winsize.height/2};
window.addEventListener('mousemove', ev => mousepos = getMousePos(ev));

// Grid (.content__slide-item element)
class GridItem {
    constructor(el) {
        this.DOM = {el: el};
        // amounts to move in each axis
        this.translationVals = {tx: 0, ty: 0};
        // get random start and end movement boundaries
        this.xstart = getRandomNumber(10, 30);
        this.ystart = getRandomNumber(10, 25);
        this.calcRect();
        window.addEventListener('resize', () => this.calcRect());
    }
    calcRect() {
        this.rect = this.DOM.el.getBoundingClientRect();
    }
    start() {
        if ( !this.requestId ) {
            this.requestId = requestAnimationFrame(() => this.render());
        }
    }
    stop() {
        if ( this.requestId ) {
            window.cancelAnimationFrame(this.requestId);
            this.requestId = undefined;
        }
    }
    // translate the item as the mouse moves
    render() {
        this.requestId = undefined;
        // Calculate the amount to move.
        // Using linear interpolation to smooth things out.
        // Translation values will be in the range of [-start, start] for a cursor movement from 0 to the window's width/height
        this.translationVals.tx = lerp(this.translationVals.tx, map(mousepos.x, 0, winsize.width, this.xstart, -this.xstart), 0.07);
        this.translationVals.ty = lerp(this.translationVals.ty, map(mousepos.y, 0, winsize.height, this.ystart, -this.ystart), 0.07);
        gsap.set(this.DOM.el, {x: this.translationVals.tx, y: this.translationVals.ty});

        // loop
        this.start();
    }
}

// Grid (.content__slide element)
class Grid {
    constructor(el, isCurrent = false) {
        this.DOM = {el: el};
        // grid items
        this.DOM.items = [...this.DOM.el.querySelectorAll('.content__slide-item')];
        // GridItem obj array
        this.gridItems = [];
        this.DOM.items.forEach(item => this.gridItems.push(new GridItem(item)));
        // Total number of items
        this.itemsTotal = this.gridItems.length;

        this.isCurrent = !isCurrent;

        if (this.isCurrent) {
            // start the grid item's movement (mousemove)
            this.startMovement();
        }
    }
    // start the grid item's movement (mousemove)
    startMovement() {
        this.gridItems.forEach(item => item.start());
    }
    // stop the grid item's movement (mousemove)
    stopMovement() {
        this.gridItems.forEach(item => item.stop());
    }
}

export default class Slideshow {
    constructor(grids) {
        this.DOM = {grids: [...grids]};
        // grids grids
        this.grids = [];
        this.DOM.grids.forEach((grid, pos) => this.grids.push(new Grid(grid, pos)));
        this.current = 0;
    }
}
